export enum ProductType {
  Base = 'Base',
  Standard = 'Standard',
  Option = 'Option',
  Upgrade = 'Upgrade',
  Custom = 'Custom'
}

export const ProductTypeIds: Record<ProductType, string> = {
  [ProductType.Base]: '11111111-1111-1111-4000-111111114001',
  [ProductType.Standard]: '11111111-1111-1111-4000-111111114002',
  [ProductType.Option]: '11111111-1111-1111-4000-111111114003',
  [ProductType.Upgrade]: '11111111-1111-1111-4000-111111114004',
  [ProductType.Custom]: '11111111-1111-1111-4000-111111114005'
};
